import { useQuery } from "@hooks/useQuery";
import { Pagination, TableColumnsType, Tabs } from "antd";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ContentWrapper, DataTable } from "~/Components";
import ActionDropdown from "~/Modules/ECMS/MAGP/StatusInformation/ActionDropdown";
import { eramanApiURL, eramanHost } from "~/Utils";
import { useContestsDocumentDetails } from "./Contests.hook";
import { useNotification } from "~/Hooks/useNotification";
import { post } from "~/Services";
import { encodeHTML } from "~/Utils/CommonUtils";
import { FieldValues } from "react-hook-form";
import { debounce } from "lodash";
import ConfirmationModal from "~/Components/Modal/confirmation-modal";
import { renderDateColumn, renderImageColumn } from "~/Utils/TableRenderFunction";

export const Participants = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [searchString, setSearchString] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [data, setData] = useState<any>([]);
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [orderByName, setOrderByName] = useState<string>("epcType");
  // const [id, setId] = useState<string | undefined>(selectedRowData?.id);
  const [selectedStatusType, setSelectedStatusType] = useState<any>('');
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const {openToast} = useNotification();
  const [file, setFile] = useState<any>(null);
  const [importModalVisible, setImportModalVisible] = useState(file? true: false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  // const {
  //   data: drilldown,
  //   error,
  //   isLoading: drilldownLoading,
  //   isError,
  //   refetch: refetchDocument,
  // } = useContestsDocumentDetails(id || "");

  // useEffect(() => {
  //   if (id) {
  //     refetchDocument();
  //   }
  // }, [id]);

  const getRecords = useCallback((
    sortOrderParam: string,
    orderByParam: string,
    searchStringParam: string,
    currentPageParam: number
  ) => {
    setIsLoading(true);
    let url = `${eramanApiURL}/admin/contest/users?contestId=${id}&sortOrder=asc&sortBy=email&pageNo=1&pageSize`;
    axios.get(url)
      .then((res: any) => {
        if (res && res.data) {
          console.log("records", res.data);
          setTotalRecords(res.data.totalRows);
          setData(res.data.data);
        }
      })
      .catch((err) => {
        setData([]);
        console.error("Error fetching data:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, currentPage);
  }, [getRecords, sortOrder, orderByName, searchString, currentPage]);

  const columns: TableColumnsType = [
    {
        title: "Name",
        dataIndex: "userName",
        key: "userName",
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
    },
    {
      title: "EPC ID",
      dataIndex: "epcId",
      key: "epcId",
    },
    // {
    //     title: "Net Price",
    //     dataIndex: "price",
    //     key: "price",
    // },
    // {
    //     title: "Total Entry",
    //     dataIndex: "totalEntry",
    //     key: "totalEntry",
    // },
    {
        title: "Submitted Date",
        dataIndex: "submittedDate",
        key: "submittedDate",
        render: renderDateColumn
    },
    // {
    //     title: "Viewed At",
    //     dataIndex: "approvedAt",
    //     key: "approvedAt",
    // },
    // {
    //     title: "Actions",
    //     dataIndex: "actions",
    //     key: "actions",
    // },
  ];

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    setCurrentPage(1);
    // getRecords(order, column.dataIndex, searchString, currentPage);
  };

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
    setCurrentPage(1);
  }, 1000);

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (apiUrl === "") return;

    

    const payload = {
      action: action,
      method: method,
      module: "Forms Submissions",
      subModule: "enquiries",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: data,
      status: status,
    };

    post("/management/publish", payload)
      .then((response) => {
        openToast({
          content: "Data Sent for Review",
          type: "success",
        });
      })
      .catch((err: any) => {
        openToast({
          content: "Failed to send data",
          type: "error",
        });
      });
  };

  async function sendDeleteUserRequest(reviewNotes: string) {
    try {
      await onSubmit(
        selectedRowData,
        `${eramanHost}/admin/epc?id=${selectedRowData?.id}`,
        "DELETE",
        "DELETE",
        "PENDING",
        reviewNotes
      );
    } catch (err) {}
  }

  return (
       <ContentWrapper title={"Participants"} showBack>
          <DataTable
            tabOffset={60}
            columns={columns.map((col: any) => ({
              ...col,
              onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
            }))}
            className="table-clickable"
            tableData={
              data ? data?.map((d:any)=>{
                return {
                  ...d,
                }
              }):[]
            }
            isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            multiSelect={false}
            hideExport={true}
            isServerSearchApi={true}
            searchPlaceholderText={"Search"}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage}
              total={totalRecords}
              onChange={(curPage) => {
                let page = curPage;
                setCurrentPage(page);
                // getRecords(sortOrder, orderByName, searchString, page);
              }}
              showSizeChanger={false}
            />
          </div>
          <ConfirmationModal
            type="delete"
            open={deleteModalVisible}
            onClose={() => setDeleteModalVisible(false)}
            onSubmit={sendDeleteUserRequest}
          />
        </ContentWrapper>
  );
};
